(function () {
  document.querySelectorAll('[data-stack-builder]').forEach(function (root) {
    var selected = {};
    var listEl = root.querySelector('[data-stack-list]');
    var totalEl = root.querySelector('[data-stack-total]');
    var checkoutBtn = root.querySelector('[data-stack-checkout]');

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' });
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    function refresh() {
      var items = Object.values(selected);
      if (items.length === 0) {
        listEl.innerHTML = '<span class="stack-list-empty">Nothing selected yet \u2014 pick vials to build a bundle.</span>';
      } else {
        listEl.innerHTML = '<ul class="stack-list-ul">' + items.map(function (i) {
          return '<li>' + escapeHtml(i.title) + '</li>';
        }).join('') + '</ul>';
      }
      var totalCents = items.reduce(function (sum, i) { return sum + i.price * 100; }, 0);
      totalEl.textContent = formatMoney(totalCents);
      totalEl.classList.remove('bump');
      void totalEl.offsetWidth;
      totalEl.classList.add('bump');
    }

    root.querySelectorAll('[data-stack-item]').forEach(function (card) {
      var variantId = card.getAttribute('data-variant-id');
      var price = parseFloat(card.getAttribute('data-price')) || 0;
      var title = card.querySelector('h4') ? card.querySelector('h4').textContent : 'Product';
      var btn = card.querySelector('[data-stack-add]');

      btn.addEventListener('click', function () {
        if (selected[variantId]) {
          delete selected[variantId];
          card.classList.remove('selected');
          btn.textContent = 'Add to stack';
        } else {
          selected[variantId] = { variantId: variantId, price: price, title: title };
          card.classList.add('selected');
          btn.textContent = 'Added \u2713';
        }
        refresh();
      });
    });

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        var items = Object.values(selected);
        if (items.length === 0) return;
        checkoutBtn.disabled = true;
        checkoutBtn.textContent = 'Adding to cart\u2026';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: items.map(function (i) {
              return { id: i.variantId, quantity: 1 };
            })
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function () {
            checkoutBtn.disabled = false;
            checkoutBtn.textContent = 'Something went wrong \u2014 try again';
          });
      });
    }

    refresh();
  });
})();
